import request from "../utils/request";

// agent/modifyUserAvatar
export function modifyUserAvatar(data) {
  return request({
    url: '/agent/modifyUserAvatar',
    method: 'post',
    data: data
  })
}

// common/uploadFile
export function uploadFile(data) {
  return request({
    url: '/common/uploadFile',
    method: 'post',
    data: data
  })
}


// agent/options/save
export function saveOptions(data) {
  return request({
    url: '/agent/options/save',
    method: 'post',
    data: data
  })
}

// contractInfo/list
export function contractInfoList(data) {
  return request({
    url: '/contractInfo/list',
    method: 'get',
    params: data
  })
}

// agent/getTaxInfo
export function getTaxInfo(data) {
  return request({
    url: '/agent/getTaxInfo',
    method: 'get',
    params: data
  })
}

// agent/agentTax
export function agentTax(data) {
  return request({
    url: '/agent/agentTax',
    method: 'post',
    data: data
  })
}

// agent/cert/certAgentSender
export function certAgentSender(data) {
  return request({
    url: '/agent/cert/certAgentSender',
    method: 'post',
    data: data
  })
}

// regin/getReginListByKeyWords
export function getReginListByKeyWords(data) {
  return request({
    url: '/regin/getReginListByKeyWords',
    method: 'get',
    params: data
  })
}

//  agent/submitAuthInfo
export function submitAuthInfo(data) {
  return request({
    url: '/agent/submitAuthInfo',
    method: 'post',
    data: data
  })
}
